export default "__VITE_ASSET__PsADjRoN__"